import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import type { HTMLAttributes, ReactNode } from 'react';
interface IProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  className?: string;
}
const Container = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mx-auto px-5 lg:px-12", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <main className={t1}>{children}</main>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default Container;